// Setup important consts
// The url of the app you want the auth to redirect to after user completes auth process
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { logoutUser } from "./api";

// Note: This is usually the url of the calling app
const redirect = (process.env.NODE_ENV === 'production')
  ? 'https://should-cost.labs.rovjok.com/callback'
  : 'http://localhost:3000/callback';

//const redirect = 'http://localhost:3000/callback';

// The developer provided appId that is initialising the auth flow
const appId = 'vBUY8CYxMHrjFJEEIRwCihU3ndzDkLyl';

// The url to the auth app
const authUrl = 'https://auth.rovjok.com/';

const useAuth = () => {

  // Intitalise the login flow
  const initialiseLogin = () => {
    window.location.replace(`${authUrl}?redirect=${redirect}&appId=${appId}`)
  }

  const getToken = () => {
    const token = localStorage.getItem('accessToken') as string;
    if (!token) return;
    try {

      console.log('getting stored token', token);
      const jwt = jwtDecode(token as string) as { [key: string]: string };
      return jwt;
    }
    catch {
      return {fullname: 'Unknown'};
    }
  }

  const logout = () => {
    return logoutUser('https://rovjok-appownsdatawebapi.azurewebsites.net/api/auth/logout').then(() => {
      localStorage.removeItem('accessToken')
      window.location.reload();
    });
  }

  const isAuthenticated = () => {
    const token = localStorage.getItem('accessToken');

    return !!token;
  }

  return {
    initialiseLogin,
    logout,
    isAuthenticated,
    getToken
  }
}

export { useAuth } ;